import React, { useState } from "react";
import { Box, Flex, Text, Spacer, Switch} from "@chakra-ui/react";

interface Props {
  toggleName: string;
  callback?: any; //in the future, can pass in functions with this
}

const AudioToggle: React.FC<Props> = ({ toggleName, callback }: Props) => {

  const callbackCheck = () => {
    if (callback) {
      console.log("callback exists");
      callback();
    } else {
      console.log("toggle clicked");
    }
  };

  return (
    <Box bg="gray.500" width="100%" borderRadius="5px">
      <Flex mt="9px" mb="9px" ml="7px" mr="7px" alignItems="center">
        <Text>
          {toggleName}
        </Text>
        <Spacer/>
        <Switch onChange={callbackCheck}/>
      </Flex>
    </Box>
  );
};

export default AudioToggle;